<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="inputVal"
        v-bind:label="label"
        prepend-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-bind:rules="rules"
        v-on="on"
        outlined
        dense
      ></v-text-field>
    </template>
    <v-date-picker
      ref="picker"
      v-model="inputVal"
      v-bind:max="maxDate"
      v-bind:min="minDate"
      v-on:change="save"
      :locale="language"
    ></v-date-picker>
  </v-menu>
</template>

<script>
// import * as dayjs from "dayjs";
export default {
  props: {
    value: String,
    label: String,
    rules: Array,
    minDate: {
      type: String,
      default: "1950-01-01",
    },
    maxDate: {
      type: String,
      default: new Date().toISOString().substr(0, 10),
    },
  },
  computed: {
    language() {
      return this.$root.$i18n.locale;
    },
    inputVal: {
      get() {
        if (this.value === "0000-00-00") {
          this.$emit("input", null);
          return null;
        }
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  data: () => ({
    date: null,
    menu: false,
  }),
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date);
    },
  },
};
</script>